module.exports = "/images/vendor/flag-icon-css/flags/4x3/be.svg?27d8ca49197f90010475d2b3646ce6b5";